import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { GzFormFieldWebComponent } from '../../../../ui/gzForm/formField';
import { Subscription } from 'rxjs';
import { ButtonColors, ButtonTypes } from '../../../../ui/gzButton/types';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { styles } from '../view/styles';
import { FormBuildConfig } from '../../../../ui/gzForm/formGroup/types/form-build-config';
import { GzDialogEvents } from '../../../../ui/gzDialog/component/GzDialog';
import { GzInputWebComponent } from '../../../../ui/gzInput/component/GzInputWebComponent';

export class GridSaveViewForm extends LitElement {
  /**
   * Default input max length is 524288;
   */
  @property({ type: Number, attribute: true, reflect: true })
  inputMaxLength = 524288;

  public formGroup: FormGroup;

  @query('#nameInput')
  nameInput!: GzFormFieldWebComponent;

  @query('#saveViewInput')
  inputComponent!: GzInputWebComponent;

  @query('#shareWithinOrgCheckbox')
  shareWithinOrgCheckbox!: GzFormFieldWebComponent;

  @query('#saveButton')
  saveButton: GzButtonWebComponent;

  @state()
  saveButtonLabel: string;

  @state()
  cancelButtonLabel: string;

  @state()
  shouldDisplayCheckbox: boolean;

  @state()
  checkboxLabel?: string;

  @state()
  nameFieldLabel: string;

  @state()
  dialogText: string;

  @state()
  nameInputErrorText: string;

  @state()
  nameInputPlaceholder: string;

  @state()
  nameInputValidators: Array<any>;

  @state()
  private subscription: Subscription | null;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-text fontSize="14">${this.dialogText}</gz-text>

      <gz-form-field label="${this.nameFieldLabel}" id="nameInput" class="pt-2">
        <gz-input
          maxLength="${this.inputMaxLength}"
          gz-form-input
          type="text"
          id="saveViewInput"
          placeholder="${this.nameInputPlaceholder}"
        ></gz-input>
        <gz-input-error id="inputError"> </gz-input-error>
      </gz-form-field>

      ${this.renderCheckbox()}

      <div class="action-buttons">
        <gz-button type="${ButtonTypes.FULL}" id="saveButton" class="mr-2" @click="${this.handleSaveButton}">
          ${this.saveButtonLabel.toUpperCase()}
        </gz-button>
        <gz-button type="${ButtonTypes.OUTLINE}" color="${ButtonColors.SECONDARY}" @click="${this.handleCancelButton}">
          ${this.cancelButtonLabel.toUpperCase()}
        </gz-button>
      </div>
    `;
  }

  public firstUpdated() {
    this.nameInput.Validators = this.nameInputValidators;

    const config: FormBuildConfig = {
      name: this.nameInput,
    };

    if (this.shouldDisplayCheckbox) {
      config['isShared'] = this.shareWithinOrgCheckbox;
    }
    this.formGroup = FormGroup.build(config);

    this.subscription = this.formGroup.valid$.subscribe({
      next: valid => {
        this.saveButton.disabled = !valid;
      },
    });

    setTimeout(() => {
      this.inputComponent.inputFocus();
    }, 100);
  }

  disconnectedCallback(): void {
    this.formGroup?.unsubscribe();
  }

  private handleCancelButton() {
    this.dispatchEvent(
      new CustomEvent(GzDialogEvents.CANCEL, {
        bubbles: true,
      })
    );
  }

  private handleSaveButton() {
    this.dispatchEvent(
      new CustomEvent(GzDialogEvents.CONFIRM, {
        bubbles: true,
        detail: {
          viewName: this.formGroup.value.name,
          isShared: this.formGroup.value.isShared,
        },
      })
    );
  }

  private renderCheckbox() {
    return this.shouldDisplayCheckbox
      ? html` <gz-form-field id="shareWithinOrgCheckbox">
          <gz-checkbox gz-form-input id="shareWithinOrgCheckboxInput" label="${this.checkboxLabel}"></gz-checkbox>
        </gz-form-field>`
      : '';
  }
}
